<template>
  <div>
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">联系我们</div>
      <div class="t-t2box">
        <input type="text" placeholder="请输入您要查询的代理商/加盟商名称" />

        <div class="chaxun">查询</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AacuxxIndex',

  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}
// 顶部
.top {
  z-index: -1;
  position: relative;
  border: 1px solid;
  width: 100%;
  height: 480px;
  background-image: url('@/image/more/daili.png');

  .t-t1 {
    font-size: 28px;
    color: #fff;
    position: absolute;
    z-index: 100;
    top: 32%;
    left: 50%;
    transform: translateX(-50%);
  }

  .t-t2box {
    display: flex;
    color: #fff;
    padding-left: 5px;
    z-index: 100;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translateX(-50%);
    align-items: center;

    input {
      border: 0;
      outline: none;
      padding: 0 10px;
      width: 620px;
      height: 44px;
      font-size: 16px;
    }
    .chaxun {
      background-color: #4581fb;
      font-size: 18px;
      line-height: 44px;
      text-align: center;
      width: 96px;
      height: 44px;
      margin-left: 30px;
      border-radius: 4px;
    }
  }
}
.top::after {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  content: '';
  display: block;
  background: rgba(0, 0, 0, 0.3);
  // background-color: #333333;
}
</style>
